module.exports = __webpack_public_path__ + "media/Lil Dicky - Freaky Friday ft. Chris Brown.d285f89d.mp3";